<div
  class="ng-overlay"
  *ngIf="isOpen"
  [attr.aria-label]="accessibilityConfig?.backgroundAriaLabel"
  [title]="accessibilityConfig?.backgroundTitle"
></div>
